<div
  class="card mb-3 risk-check-card"
  [class.expanded]="isExpanded()"
  [style.border-left]="'4px solid ' + severityColor()"
  (click)="onToggle()"
  role="button"
>
  <div class="card-body py-3 px-4">
    <div class="d-flex justify-content-between align-items-start">
      <div class="flex-grow-1">
        <div class="d-flex align-items-center gap-2 mb-1">
          <h6 class="mb-0 fw-semibold">{{ riskCheck().title }}</h6>
          <span [class]="severityBadgeClass()">
            {{ riskCheck().severity }}
          </span>
          @if (riskCheck().state === 'Accepted') {
            <span class="severity-badge severity-neutral">Accepted Risk</span>
          }
        </div>
        <p class="text-muted mb-2 small">{{ riskCheck().description }}</p>

        <div class="d-flex align-items-center gap-4 flex-wrap">
          <!-- Order matters. `notEvaluated` has to win before any counter is read: a
               tenant-scoped check we could not read still reports 1 / 1, and comparing
               those two would print "Configured" about settings nobody could see. -->
          @if (notEvaluated()) {
            <span class="fw-medium not-evaluated-reason">
              Not Evaluated@if (riskCheck().detail) {<span class="fw-normal">: {{ riskCheck().detail }}</span>}
            </span>
          } @else if (nothingInScope()) {
            <span class="fw-medium text-muted">No {{ entityNoun() }} to assess</span>
          } @else if (riskCheck().scope === 'tenant') {
            <span class="fw-medium">
              {{ riskCheck().protected_entities >= riskCheck().total_entities ? 'Configured' : 'Needs configuration' }}
            </span>
          } @else {
            <span class="fw-medium">
              {{ riskCheck().protected_entities }} / {{ riskCheck().total_entities }} {{ entityNoun() }} protected
            </span>
          }

          @if (acceptedCount() > 0 && riskCheck().state !== 'Accepted') {
            <span class="text-muted fw-medium small">
              {{ acceptedCount() }} / {{ failedCount() }} accepted
            </span>
          }

          @if (riskCheck().linked_case_count > 0) {
            <button
              type="button"
              class="btn btn-sm btn-outline-secondary d-inline-flex align-items-center gap-1 ms-auto view-cases-btn"
              (click)="onViewCases($event)"
            >
              <i class="bi bi-eye"></i>
              View {{ riskCheck().linked_case_count }} linked
              case{{ riskCheck().linked_case_count === 1 ? '' : 's' }}
            </button>
          }
        </div>

        @if (riskCheck().impact_percentage > 0) {
          <div class="mt-1">
            <span class="text-muted small">
              &rarr; Fixing this could reduce up to <strong>{{ riskCheck().impact_percentage }}%</strong> of identity incidents
            </span>
          </div>
        }
      </div>

      <div class="expand-indicator text-muted">
        @if (isExpanded()) {
          <i class="bi bi-chevron-up"></i>
        } @else {
          <i class="bi bi-chevron-down"></i>
        }
      </div>
    </div>
  </div>
</div>

@if (showCasesPopup()) {
  <app-linked-cases-popup
    [cases]="riskCheck().linked_cases"
    [title]="riskCheck().title"
    [subtitle]="casesSubtitle()"
    (close)="onCloseCasesPopup()"
  />
}
